<script lang="ts">
	// Services
	import { format } from '../../services/i18n';
	// Helpers
	import { navigateToShop } from './list-helpers';
	import { capFirstChar } from 'src/helpers/utilities';
	// Components
	import EmptyList from './EmptyList.svelte';
	// Stores
	import { user_data } from 'src/stores/account/user';

	export let storeUrl = `https://www.shelly.cloud/en/products/shop?origin=shelly_app&shelly_user=${$user_data.email}#43e73c569e094a20aabe8d83a5f2426d`;
	export let withoutMargin = false;
	export let type: 'page' | 'modal' | 'drawer' = 'page';
</script>

<EmptyList
	{type}
	{withoutMargin}
	title={$format('on_board_get_device_title', {
		default: 'Get the necessary devices to set up',
	})}
	description={$format('on_board_get_device_description', {
		default:
			'Currently you don’t have the necessary devices. Please get the necessary devices to set up your automations.',
	})}
	btnText={capFirstChar(
		$format('button_go_to_store', {
			default: 'Go to store',
		}).toLocaleLowerCase(),
	)}
	onClick={() => {
		navigateToShop(storeUrl);
	}}
/>
